import FirebaseWrite from "@/services/database/firebaseWrite";
import TimeStamp from "@/services/timeStamp";

export class SpielerRollenService {
    constructor(roles, setupForm, spieler) {
        this.roles = roles === undefined ? {} : roles
        this.atLeastOneRoleWaitingForPassPrint = false
        this.dateLocaleOptionsLong = {year: "numeric", month: "numeric", day: "numeric",
            hour: "numeric", minute: "numeric"}
        this.schiedsrichter = {
            roleKeys: ['osr', 'sr'],
            permissions: 'lv' + spieler?.passNr.substring(0,2)
        }
        this.trainer = {
            roleKeys: ['uel', 'instr', 'tr'],
            permissions: 'lv' + spieler?.passNr.substring(0,2)
        }
        this.roleForm = []
        this.lvId = ''
        if ( setupForm ) this.createRoleForm(spieler)
        this.spieler = spieler
        this.isSaved = false;
    }

    hasRoles(){
        if ( !this.roles ) return false
        return Object.keys(this.roles).length > 2 // isSchiedsrichter and isTrainer are not counted
    }

    getFullRoleName(role){
        switch (role) {
            case 'osr': return 'Oberschiedsrichter';
            case 'sr': return 'Schiedsrichter';
            case 'uel': return 'Übungsleiter';
            case 'instr': return 'Instruktor';
            case 'tr': return 'Trainer';
            default: return '';
        }
    }

    getNrLabel(role){
        switch (role) {
            case 'osr': return 'OSR-Nummer';
            case 'sr': return 'SR-Nummer';
            case 'uel': return 'ÜL-Nummer';
            case 'instr': return 'IN-Nummer';
            case 'tr': return 'TR-Nummer';
            default: return 'Nummer';
        }
    }

    getSort(role){
        switch (role) {
            case 'osr': return 10;
            case 'sr': return 20;
            case 'uel': return 30;
            case 'instr': return 40;
            case 'tr': return 50;
            default: return 100;
        }
    }

    addPendingPassPrintsToList(list, history){
        if ( !this.hasRoles() ) return list
        Object.keys(this.roles).forEach( (role) => {
            if ( role !== 'isSchiedsrichter' && role !== 'isTrainer' ) {
                if ( this.roles[role].waitingForPassPrint && !history.show ) {
                    list.push({type: role, selected: false, label: this.getFullRoleName(role)})
                } else if (this.roles[role].tsLastPassPrint >= history.fromTs &&
                    this.roles[role].tsLastPassPrint <= history.untilTs &&
                    history.show ) {
                    list.push({type: role, selected: false,
                        label: this.getFullRoleName(role) + this.showDate(history.show, this.roles[role].tsLastPassPrint)})
                }
            }
        });
        return list
    }
        showDate(showHistory, lastPrintDate){
            return !showHistory ? '' :
                ' / ' + TimeStamp.getLocalDateAndTime(lastPrintDate)
        }

// functions for role edit form only

    createRoleForm(spieler){
        this.lvId = spieler.passNr.substring(0,2)
        this.createRoleFormData(this.schiedsrichter, this.lvId)
        this.createRoleFormData(this.trainer, '')
    }
        createRoleFormData(roleGroup, lvId){
            roleGroup.roleKeys.forEach( (roleKey) => {
                if ( this.roles[roleKey] ) {
                    const roleData = JSON.parse(JSON.stringify(this.roles[roleKey]))
                    const tsLastPassPrint = roleData.tsLastPassPrint
                    roleData.permissions = roleGroup.permissions
                    roleData.role = roleKey
                    roleData.sort = this.getSort(roleKey)
                    roleData.tsLastPassPrint = tsLastPassPrint === 0 ? '-' : new Date(tsLastPassPrint).toLocaleString(
                        'de', this.dateLocaleOptionsLong)
                    roleData.tsRaw = tsLastPassPrint
                    roleData.label = this.getNrLabel(roleKey)
                    roleData.emptylabel = this.getFullRoleName(roleKey)
                    roleData.isEdited = false
                    this.roleForm.push(roleData)
                } else {
                    this.roleForm.push({
                        role: roleKey,
                        von: '', bis: '',
                        lvId: lvId,
                        nr: '',
                        tsLastPassPrint: 0,
                        tsRaw: 0,
                        waitingForPassPrint: false,
                        permissions: roleGroup.permissions,
                        sort: this.getSort(roleKey),
                        label: this.getNrLabel(roleKey),
                        emptylabel: this.getFullRoleName(roleKey),
                        isEdited: false,
                    })
                }
            });
        }

    async saveRolesFromRoleForm(){
        this.isSaved = true
        const updatedRoles = this.getRoleMapForSaving()
        await FirebaseWrite.update('spieler', this.spieler.id, {
            roles: updatedRoles,
            waitingForPassPrint: this.atLeastOneRoleWaitingForPassPrint || this.spieler.waitingForPlayerPassPrint === true
        }, true)
        this.roles = updatedRoles
        this.spieler.roles = updatedRoles
        this.roleForm = []
        this.createRoleForm(this.spieler)
        setTimeout(()=>{ this.isSaved = false; }, 300)
    }
        getRoleMapForSaving(){
            const roles = {}
            const roleForm = JSON.parse(JSON.stringify(this.roleForm))
            this.atLeastOneRoleWaitingForPassPrint = false
            roleForm.forEach( (formRole) => {
                if ( formRole.nr ) {
                    const waitingForPassPrint = this.getWaitingForPassPrint(formRole)
                    if ( waitingForPassPrint ) this.atLeastOneRoleWaitingForPassPrint = true
                    roles[formRole.role] = {
                        nr: formRole.nr,
                        von: formRole.von,
                        bis: formRole.bis,
                        lvId: formRole.lvId,
                        tsLastPassPrint: formRole.tsRaw,
                        waitingForPassPrint: waitingForPassPrint
                    }
                }
            });
            roles.isSchiedsrichter = roles?.sr !== undefined || roles?.osr !== undefined
            //if ( !roles.isSchiedsrichter ) roles.isSchiedsrichter = ''
            roles.isTrainer = roles.tr !== undefined || roles.uel !== undefined || roles.instr !== undefined
            return roles
        }
        getWaitingForPassPrint(formRole){
            if ( formRole.waitingForPassPrint ) {
                return true
            } else {
                const savedRole = this.spieler?.roles?.[formRole.role]
                if ( !savedRole) return true
                return savedRole.nr !== formRole.nr ||
                       savedRole.von !== formRole.von ||
                       savedRole.bis !== formRole.bis ||
                       savedRole.lvId !== formRole.lvId
            }
        }

    rolesHasBeenChanged(){
        for ( let i = 0; i < this.roleForm.length; i++ ) {
            const itemStatus =this.getStatus(this.roleForm[i]).status
            if ( this.itemIsDeleted(itemStatus) ||
                 this.itemIsNew(itemStatus) ||
                 this.itemIsChanged(itemStatus) ) return true
        }
        return false
    }

    clearItem(roleItem){
        roleItem.von = ''
        roleItem.bis = ''
        roleItem.nr = ''
        roleItem.isEdited = true
    }

    undoItem(roleItem){
        const savedRoleItem = this.roles[roleItem.role]
        if ( !savedRoleItem ) {
            this.clearItem(roleItem)
            roleItem.isEdited = false
        } else {
            roleItem.von = savedRoleItem.von
            roleItem.bis = savedRoleItem.bis
            roleItem.nr = savedRoleItem.nr
            roleItem.isEdited = false
        }
    }

    getStatus(roleItem){
        const status = {
            isEmpty: !roleItem.nr && !roleItem.von && !roleItem.bis,
            completionStatus: roleItem.nr && roleItem.bis &&
                (roleItem.bis > roleItem.von || !roleItem.von),
            isSaved: this.roles[roleItem.role] !== undefined,
            isChanged: this.roles[roleItem.role] !== undefined && (
                roleItem.nr !== this.roles[roleItem.role]?.nr ||
                roleItem.von !== this.roles[roleItem.role]?.von ||
                roleItem.bis !== this.roles[roleItem.role]?.bis)
        }
        if ( status.isEmpty && !status.isSaved ) { return {icon: '', tooltip: '', color: '', status: status} }
        if ( this.itemIsDeleted(status) ) { return {icon: 'mdi-delete', tooltip: '', color: 'warning', status: status} }
        if ( !status.completionStatus ) { return {icon: 'mdi-alert', tooltip: '', color: 'error', status: status} }
        if ( this.itemIsNew(status) ) { return {icon: 'mdi-plus', tooltip: '', color: 'warning', status: status} }
        if ( status.isSaved && !status.isChanged ) { return {icon: 'mdi-check', tooltip: '', color: 'success', status: status} }
        if ( this.itemIsChanged(status) ) { return {icon: 'mdi-pencil', tooltip: '', color: 'warning', status: status} }
        return 'saved'
    }
        itemIsNew(status){ return status.completionStatus && !status.isSaved }
        itemIsChanged(status){ return status.isSaved && status.isChanged && status.completionStatus }
        itemIsDeleted(status){ return status.isEmpty && status.isSaved }

}